<sh-form-group
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [required]="profileField.Required"
    [helpText]="profileField.Description"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [title]="disabledMessageKey | translate"
>
    <p *ngIf="isBulkEdit$ | async" class="sh-form-group__warning sh-preserve-linebreaks">
        {{ "profile-form.complex-input-field.bulk-edit-warning" | translate: { fieldName: profileField.DisplayLabel } }}
    </p>
    <p *ngIf="isBatchEdit" class="sh-form-group__warning sh-preserve-linebreaks">
        {{ "profile-form.complex-input-field.batch-edit-warning" | translate: { fieldName: profileField.DisplayLabel } }}
    </p>

    <!-- Merge Strategy Component-->
    <ng-content></ng-content>

    <ng-container *ngFor="let profileField of childProfileFields$ | async">
        <sh-generic-field
            *ngIf="profileField.FieldDefinition; else notFound"
            [style]="nestedPadding$ | async"
            [profileField]="profileField"
            [formGroup]="formGroup"
            [records]="records$ | async"
            [isBatchEdit]="isBatchEdit"
            [canEditStandard]="canEdit$ | async"
            [canEditAdvanced]="canEdit$ | async"
            [nestedIndex]="(nestedIndex$ | async)! + 1"
            [autocompleteFct]="undefined"
        >
        </sh-generic-field>

        <ng-template #notFound>
            <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
            <dd class="sh-description-list__details">{{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}</dd>
        </ng-template>
    </ng-container>
</sh-form-group>
